(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/widgets/casino-game-list/assets/javascripts/live-game-updater.js') >= 0) return;  svs.modules.push('/widgets/casino-game-list/assets/javascripts/live-game-updater.js'); "use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

(function (svs) {
  'use strict';

  svs.widget = svs.widget || {};
  svs.widget.casino_game_list = svs.widget.casino_game_list || {};

  var LiveGameUpdater = function () {
    function LiveGameUpdater(el) {
      _classCallCheck(this, LiveGameUpdater);

      var name = el.data('gamename');
      this.gameModel = svs.widget.casino_game_list.data.games.filter(function (game) {
        return game.name === name;
      })[0];
      var supplier = this.gameModel.clientStartType;
      var liveGameId = this.gameModel.providerGameId;
      this.el = el;
      var liveSocketUrl = "/casino/lobby/games/".concat(liveGameId.toLowerCase(), "?supplier=").concat(supplier);
      svs.core.socket.subscribe(liveSocketUrl, this.update, this);
    }

    _createClass(LiveGameUpdater, [{
      key: "update",
      value: function update(data) {
        if (data.game) {
          for (var key in data.game) {
            if (Object.prototype.hasOwnProperty.call(data.game, key)) {
              this.gameModel[key] = data.game[key];
            }
          }

          this.el.html(svs.casino.live_info.templates.casino_live_info(this.gameModel));
        }
      }
    }]);

    return LiveGameUpdater;
  }();

  svs.widget.casino_game_list.LiveGameUpdater = LiveGameUpdater;
})(svs);
 })(window);